import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { WidgetStateFrontEnd } from '../../../../genericDashboard/gzGenericWidget/types';
import { styles } from '../view/styles';
import { WEB_COMPONENT_EASM_VULNERABLE_SERVERS } from '../../../../webcomponents.constants';
import { EasmVulnerableServersPayload } from '../../../../../../../libs/shared/dtos/types/widgets/src/lib/shared-dtos-widgets-common';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { store } from '../../../../redux/store';
import { selectDashboardFilterValues } from '../../../../genericDashboard/redux/dashboard.filters.slice';
import { GenericDashboardsFiltersHelper } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { FilterType } from '../../genericTopData/types/types';
import { generateFiltersForInventory } from '../../../utils/utils';
import { FindingType } from '../../../types';

@customElement(WEB_COMPONENT_EASM_VULNERABLE_SERVERS)
export class GzEasmVulnerableServersWebComponent extends GzGenericWidgetContent {
  @property({
    type: WidgetStateFrontEnd,
    attribute: true,
    reflect: true,
  })
  state: WidgetStateFrontEnd;

  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: EasmVulnerableServersPayload;

  static get styles() {
    return styles;
  }

  protected renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader>`;
  }

  protected renderContent(): TemplateResult {
    if (this.state !== WidgetStateFrontEnd.IS_EMPTY && this.payload?.vulnerableServers?.total !== undefined) {
      return html`
        <div class="vulnerable-servers-number fs-48 flex-center clickable" @click="${this.navigateToInventory}">
          ${this.payload?.vulnerableServers?.total}
        </div>
      `;
    }

    return html` <div class="vulnerable-servers-number fs-48 flex-center">${'--'}</div> `;
  }

  protected async navigateToInventory(): Promise<void> {
    const dashboardAppState = store.getState().dashboardsApp;
    const filters = selectDashboardFilterValues(dashboardAppState);
    const companyId = GenericDashboardsFiltersHelper.getCompanyIdFromSingleSelectCompanyFilter(filters) as string;

    const isVulnerableFilters = generateFiltersForInventory(FilterType.VULNERABLE_TO_ZONE_TRANSFER, '', companyId, [1]);
    const assetTypeFilters = generateFiltersForInventory(FilterType.FINDING_TYPE, '', companyId, [
      FindingType.DNS_RECORD,
    ]);

    await NavigationHelper.navigateToEASMArtifactsInventory({
      smartViewId: this.payload?.inventorySmartViewId as string,
      filters: [...isVulnerableFilters, ...assetTypeFilters],
    });
  }

  public async handleTitleClick() {
    await this.navigateToInventory();
  }
}
